import { Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconMailFilled } from '@zillow/constellation-icons';

import type { Lease } from '../../../shared/models';
import * as constants from './constants';
import FaqAccordion from '../Widgets/FaqAccordion';
import WhoHasSigned from '../Widgets/WhoHasSigned';

type Props = {
  isInSignOnlineMode: boolean;
  lease: Lease;
};

export default function LeaseSentContent({ isInSignOnlineMode, lease }: Props): JSX.Element {
  const content = lease.isSelfUpload
    ? constants.SELF_UPLOAD.LEASE_SENT_CONTENT
    : isInSignOnlineMode
      ? constants.SIGN_ONLINE.LEASE_SENT_CONTENT
      : constants.PRINT_TO_SIGN.LEASE_SENT_CONTENT;

  return (
    <Box css={{ display: 'flex', gap: 'tight', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Icon size="lg" css={{ color: 'icon.feedback.success.strong' }}>
        <IconMailFilled />
      </Icon>
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.heading-sm' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
        }}
      >
        {content.TITLE}
      </Heading>
      <Paragraph>
        {isInSignOnlineMode
          ? `You can countersign the lease after your renters and your co-landlord have signed. We also recommend waiting to
        countersign until you’ve collected any deposits. Tell your renters to look for an email with a link to the
        lease.`
          : `You’ve sent your lease for review. We recommend waiting to countersign until you’ve collected any deposits.`}
      </Paragraph>
      {isInSignOnlineMode && <WhoHasSigned isInitiallyExpanded leaseId={lease.id} />}
      <div>
        <FaqAccordion initialExpandedIndex={0} title="You may be wondering…" sections={content.FAQ} />
      </div>
    </Box>
  );
}
